import React from 'react';
import ButtonGroup from '@/Components/ButtonGroup';
import IconCopy from '@/svgs/copy.svg?react';
import CopyContentButton from '@/Components/CopyContentButton';
import ApplySuggestion from './ApplySuggestion';
import CreateSnippet from './CreateSnippet';
import Button from './Button';
import useTypedPage from '@/Hooks/useTypedPage';
import InlineSvg from '../InlineSvg';

export default function Toolbar({
  code,
  language,
}: {
  code: string;
  language?: string;
}) {
  const { file, current_route_name } = useTypedPage<{
    file: App.Data.FileData;
    current_route_name: string;
  }>().props;

  return (
    <div className="not-prose flex justify-between rounded-t-xl bg-brand-50 p-2 text-black dark:bg-brand-dark-50 dark:text-white">
      <InlineSvg slug={`svgs/logo-${language}`} className="h-6 w-6" />
      <ButtonGroup>
        {!file && <CreateSnippet code={code} language={language} />}
        {file && current_route_name !== 'snippet.show' && (
          <ApplySuggestion code={code} file={file} />
        )}
        <CopyContentButton content={code}>
          <Button>
            <IconCopy className="h-4 w-4" />
          </Button>
        </CopyContentButton>
      </ButtonGroup>
    </div>
  );
}
